import { useRef, useState } from "react";
import * as React from 'react'
import Collapse from "@kunukn/react-collapse"
function BookingType({handleOnChange, currentRadioValue}:any) {
  
    return ( 
      <>
       <div className="row pb-2">
            <div className="col-lg-5 col-md-6 col-sm-6">
        <div className=" p-2">
          <input className=" form-field "
            id="bookingType-1"
            name="Individual"
            type="radio"
            value="Individual"
            onChange={handleOnChange}
            checked={currentRadioValue === 'Individual'}
          />
          <label className="pl-1" htmlFor="bookingType-1"> Individual Booking</label>
        </div>
        </div>
        <div className="col-lg-5 col-md-6 col-sm-6">
        <div  className=" p-2">
          <input
          className=" form-field "
            id="bookingType-2"
            name="Group"
            type="radio"
            value="Group"
            onChange={handleOnChange}
            checked={currentRadioValue === 'Group'}
          />
          <label className="pl-1" htmlFor="bookingType-2">Group Booking</label>
        </div>
        </div>
        </div>

      </>
    );
  }
  function PayType({handleOnChange, currentRadioValue}:any) {
  
    return ( 
      <>
       <div className="row pt-2">
            <div className="col-lg-5 col-md-6 col-sm-6">
        <div className=" p-2">
          <input className=" form-field "
            id="payType-1"
            name="PayNow"
            type="radio"
            value="PayNow"
            onChange={handleOnChange}
            checked={currentRadioValue === 'PayNow'}
          />
          <label className="pl-1" htmlFor="payType-1"> Pay Now</label>
        </div>
        </div>
        <div className="col-lg-5 col-md-6 col-sm-6">
        <div  className=" p-2">
          <input
          className=" form-field "
            id="payType-2"
            name="GenerateInvoice"
            type="radio"
            value="GenerateInvoice"
            onChange={handleOnChange}
            checked={currentRadioValue === 'GenerateInvoice'}
          />
          <label className="pl-1" htmlFor="payType-2">Generate Invoice &amp; Payment Link for later payment</label>
          <label className="pl-1 warningmg" htmlFor="payType-2">(Registration confirmation subject to payment completion)</label>
        </div>
        </div>
        </div>

      </>
    );
  }
  interface InputComponentProps {
    custname: any
    custplaceholder:any
    custid:any
    onExternalBind?: any
    readonly?:any
    type?:any
    toupper?:any
    trim?:any
    onExternalValue?:  (val: any) => void
  }
  export const InputComponent: React.FunctionComponent<InputComponentProps> = ({custname , custplaceholder, custid, onExternalBind, onExternalValue, readonly, type='text', toupper=false, trim=false }:InputComponentProps) => {
     return (
      
        <div className="form-field form-label-group-cust ">
            <input id={custid} type={type} className="form-control-cust" name={custname} placeholder={custplaceholder} value={onExternalBind} readOnly={readonly} onChange={(event) => {
         
            if(  onExternalValue)
            {
              if(toupper && trim)
              {
                onExternalValue(event.target.value.trim().toUpperCase());
              }
              else if(toupper)
              {
                onExternalValue(event.target.value.toUpperCase());
              }
              else if(trim)
              {
                onExternalValue(event.target.value.trim());
              }
              else
              {
                onExternalValue(event.target.value);
              }
            }
        
        }} />
            <label htmlFor={custid}>{custplaceholder}</label>
        </div>
    );
}


interface FileUploadComponentProps {
  custname: any
  custplaceholder:any
  custid:any
  onExternalBind?: any
  readonly?:any
  type?:any
  onExternalValue?:  (val: any) => void
  onChange?:  (val: any) => Promise<boolean>
}
export const FileUploadComponent: React.FunctionComponent<FileUploadComponentProps> = ({custname , custplaceholder, custid, onExternalBind, onExternalValue, readonly, type='text', onChange }:FileUploadComponentProps) => {
   return (
    
      <div className="form-field form-label-group-cust ">
          <input id={custid} type="file" className="form-control-cust" name={custname} placeholder={custplaceholder} onChange={(event) => {
          let isvalid = true;
           if(onChange)
           { 
            return onChange(event);
          }
      }} />
          <label htmlFor={custid}>{custplaceholder}</label>
      </div>
  );
}
interface TextAreaComponentProps {
  custname: any
  custplaceholder:any
  custid:any
  onExternalBind?: any
  readonly?:any
  type?:any
  onExternalValue?:  (val: any) => void
}
export const TextAreaComponent: React.FunctionComponent<TextAreaComponentProps> = ({custname , custplaceholder, custid, onExternalBind, onExternalValue, readonly, type='text' }:InputComponentProps) => {
   return (
    
      <div className="form-field form-label-group-cust ">
          <textarea id={custid}  className=" " style={{width :"100%", borderColor:"#c8cdd2"}} name={custname} placeholder={custplaceholder} value={onExternalBind} readOnly={readonly} onChange={(event) => {
           if( onExternalValue)
           {
            onExternalValue(event.target.value);
           }
       
      }} />
          <label htmlFor={custid}>{custplaceholder}</label>
      </div>
  );
}

interface CheckboxComponentProps {
  custname: any
  custplaceholder:any
  custid:any
  onExternalBind?: any
  readonly?:any
  type?:any
  onExternalValue?:  (val: any) => void
}
export const CheckboxComponent: React.FunctionComponent<CheckboxComponentProps> = ({custname , custplaceholder, custid, onExternalBind, onExternalValue, readonly, type='text' }:InputComponentProps) => {
  const [isChecked,setIsChecked] = useState(onExternalBind?onExternalBind:false);
  return (
   <>
    <div className="form-group form-check ">
    <input type="checkbox" className="form-check-input" checked={onExternalBind?onExternalBind:isChecked}  name={custname} id={custid} onChange={(event) => {
          if( onExternalValue)
          {
            setIsChecked(!isChecked);
            onExternalValue(!isChecked);
          }
      
     }}/>
    <label className="form-check-label" htmlFor={custid}>{custplaceholder}</label>
  </div>
     </>
 );
}

function NumberInputComponent({custname , custplaceholder, custid, min, max }:any)
{
  
    return (
        <div className="form-field form-label-group-cust ">
            <input id={custid} type="number" min={min} max={max} className="form-control-cust" name={custname} placeholder={custplaceholder} />
            <label htmlFor={custid}>{custplaceholder}</label>
        </div>
    );
}

function QuantityComponent({custname , custplaceholder, custid, onIncrement, onDecrement, currentValue,ticketCount , setTicketCount , price}:any)
{
    if (currentValue==null)
    {
        currentValue=0;
    }
    return (
        <>
        <div className="form-field form-label-group-cust">
         <span className="mx-3 children">{custplaceholder} ( &#8377; {price})</span>
         <div className="quantityouter">
                <button type="button" className="btn btn-outline-primary increment_btn quantitybox"  onClick={() =>onDecrement(custplaceholder,ticketCount , setTicketCount)}>-</button>
                <span id={custid} className="mx-3 children">{currentValue}</span>
                <button type="button" className="btn btn-outline-primary increment_btn quantitybox" onClick={() =>onIncrement(custplaceholder,ticketCount , setTicketCount)}>+</button>
                </div>
             </div>
</>
    );
}
interface DropDownComponentProps {
  custname: any
  custplaceholder:any
  custid:any
  names:any
  onExternalValue?:  (val: any) => void
  externalstateValue?:  any
  readonly?: boolean
}

export const DropDownComponent: React.FunctionComponent<DropDownComponentProps> = ({custname, custplaceholder, custid, names, onExternalValue, externalstateValue, readonly=false}:DropDownComponentProps) => {
  const [ ticketTypeSelected ,  setTicketTypeSelected] = useState(custplaceholder);
  const [activecss,setActivecss] = useState(false);
const onclickhandle = ()=>{
  if (!readonly) {
    setActivecss(!activecss);
  }
};
const handleLiClick = (val)=>{
  if(onExternalValue!=null)
  {
    onExternalValue(val);
  }
  setTicketTypeSelected(val);
};
const handleFocusLiClick = ()=>{
};
const handleFocus = (val) => {
};

    return (
      <div className="form-field wow fadeInUp form-label-group-cust " data-wow-duration="400ms">
      <div className={"drop-menu "+ (activecss ? " active " : "" )} onClick={onclickhandle}  onFocus={()=>handleFocus} onBlur={()=>handleFocusLiClick}>
          <div className="select">
              <span>{externalstateValue?externalstateValue:ticketTypeSelected}</span>
              <i className="fa fa-caret-down"></i>
          </div>
          <Collapse
        isOpen={activecss}
        transition="height 300ms cubic-bezier(0.4, 0, 0.2, 1)"
      >
        <input type="hidden" name={custname} value={externalstateValue?externalstateValue:ticketTypeSelected}/>
          <ul className={"dropeddown "+ (activecss ? " active " : "" )}>
              <li onClick={()=>handleLiClick(custplaceholder)}>--{custplaceholder}--</li>
              {
                names.map((value)=>{
                  return <li onClick={()=>handleLiClick(value)}>{value}</li>
                })
              }
          </ul>
      </Collapse>
      </div>
  </div>
    );
}


interface MaterialMenuComponentProps {
  custname: any
  custplaceholder:any
  custid:any
  names:any
  onExternalValue?:  (val: any) => void
  externalstateValue?:  any
}

export const MaterialMenuComponent: React.FunctionComponent<MaterialMenuComponentProps> = ({custname, custplaceholder, custid, names, onExternalValue, externalstateValue}:DropDownComponentProps) => {
  const [ ticketTypeSelected ,  setTicketTypeSelected] = useState(custplaceholder);
  const [activecss,setActivecss] = useState(false);
const onclickhandle = ()=>{
  setActivecss(!activecss);
};
const handleLiClick = (val)=>{
  if(onExternalValue!=null)
  {
    onExternalValue(val);
  }
  setTicketTypeSelected(val);
};
const handleFocusLiClick = ()=>{
};
const handleFocus = (val) => {
};

    return (
      <div  data-wow-duration="400ms">
      <div className={"drop-menu "+ (activecss ? " active " : "" )} onClick={onclickhandle}  onFocus={()=>handleFocus} onBlur={()=>handleFocusLiClick}>
          <div className="select">
              <span>  <i className="fa fa-solid fa-pencil"></i></span>
          </div>
          <Collapse
        isOpen={activecss}
        transition="height 300ms cubic-bezier(0.4, 0, 0.2, 1)"
      >
        <input type="hidden" name={custname} value={externalstateValue?externalstateValue:ticketTypeSelected}/>
          <ul className={"dropeddown "+ (activecss ? " active " : "" )}>
              <li onClick={()=>handleLiClick(custplaceholder)}>--{custplaceholder}--</li>
              {
                names.map((value)=>{
                  return <li onClick={()=>handleLiClick(value)}>{value}</li>
                })
              }
          </ul>
      </Collapse>
      </div>
  </div>
    );
}

export { BookingType, NumberInputComponent, QuantityComponent,PayType};
